export const addfilterdata = (filteredRecords) => ({
    type: 'FILTER_RECORDS',
    payload: filteredRecords,
  });